import { AnimatePresence } from 'framer-motion'
import React from 'react'

import { useManagementSearchSimTypes } from '@apps-common/apis/management/sim-type'
import { SimTypeCardSkeleton, SimTypeListCard } from '@apps-common/apps/portal/pages/management/components/sim-type'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'

interface IProps {
  searchVal: string
}

export const SimTypeInfiniteView: React.FC<IProps> = ({ searchVal }) => {
  const { isLoading, isError, data, isRefetching, refetch } = useManagementSearchSimTypes({
    search: searchVal
  })

  const loading = isLoading || isRefetching || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[60px]'>
        <PullRefresh loading={isRefetching} callback={() => refetch()} />
        <AnimatePresence>
          <div className='flex flex-col gap-4'>
            {loading && Array.from(Array(10).keys()).map((n, i) => <SimTypeCardSkeleton key={`sim-type-card-skeleton-${i}`} />)}
            {!loading && data?.map((s) => <SimTypeListCard key={`sim-type-list-${s.id}`} simType={s} />)}
            {!loading && data && data.length === 0 && <NoResultsCard>No sim type results.</NoResultsCard>}
          </div>
        </AnimatePresence>
      </LayoutPadding>
    </LayoutContainer>
  )
}
